(function () {

'use strict';

/* ==========================================================
   CONFIG
========================================================== */

const STORAGE_KEY = 'ns_delivery_pincode';

/* ==========================================================
   CACHE
========================================================== */

let deliveryLookup = null;
let csvLoaded = false;

let holidaySet = new Set();
let holidayLoaded = false;

/* ==========================================================
   INITIALIZE
========================================================== */

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('shopify:section:load', init);

function init() {

    document
        .querySelectorAll('[data-estimated-delivery]')
        .forEach(initDeliveryChecker);

}

/* ==========================================================
   COMPONENT
========================================================== */

async function initDeliveryChecker(root) {

    if (root.dataset.initialized === 'true') return;

    root.dataset.initialized = 'true';

    const input = root.querySelector('[data-delivery-input]');
    const checkButton = root.querySelector('[data-delivery-check]');
    const changeButton = root.querySelector('[data-delivery-change]');

    const entry = root.querySelector('[data-delivery-entry]');
    const result = root.querySelector('[data-delivery-result]');
    const error = root.querySelector('[data-delivery-error]');
    const loading = root.querySelector('[data-delivery-loading]');

    const location = root.querySelector('[data-delivery-location]');
    const status = root.querySelector('[data-delivery-status]');
    const dates = root.querySelector('[data-delivery-dates]');

    const csvUrl = root.dataset.deliveryCsv;
    const holidayCsv = root.dataset.holidayCsv;

    await loadCSV(csvUrl);
    await loadHolidayCSV(holidayCsv);

    const savedPincode = localStorage.getItem(STORAGE_KEY);

    if (savedPincode) {

        input.value = savedPincode;

        lookupPincode(savedPincode, root);

    }

    

    input.addEventListener('input', function () {

    const value = input.value.replace(/\D/g, '');

    input.value = value;

    error.hidden = true;

    if (value.length === 6) {

        lookupPincode(value, root);

    } else {

        result.hidden = true;

    }

});

input.addEventListener('blur', function () {

    if (input.value.length > 0 && input.value.length < 6) {

        error.hidden = false;

        error.querySelector('p').textContent =
            "Please enter a valid 6-digit pincode.";

    }

});

    input.addEventListener('input', function () {

        this.value = this.value
            .replace(/\D/g, '')
            .slice(0, 6);

        if (this.value.length === 6) {

            lookupPincode(this.value, root);

        }

    });

    if (changeButton) {
    changeButton.addEventListener('click', function () {
        input.focus();
    });
}

}

/* ==========================================================
   LOAD DELIVERY CSV
========================================================== */

async function loadCSV(csvUrl) {

    if (csvLoaded) return;

    deliveryLookup = new Map();

    const response = await fetch(csvUrl);

    if (!response.ok) {

        console.error('Unable to load delivery CSV.');

        return;

    }

    const csv = await response.text();

    parseCSV(csv);

    csvLoaded = true;

}

function parseCSV(csv) {

    const rows = csv.trim().split(/\r?\n/);

    if (rows.length <= 1) return;

    for (let i = 1; i < rows.length; i++) {

        const cols = rows[i].split(',');

        if (cols.length < 4) continue;

        deliveryLookup.set(cols[0].trim(), {

            min: parseInt(cols[1], 10),
            max: parseInt(cols[2], 10),
            serviceable: cols[3].trim().toUpperCase() === 'Y'

        });

    }

}

/* ==========================================================
   LOAD HOLIDAY CSV
========================================================== */

async function loadHolidayCSV(csvUrl) {

    if (holidayLoaded) return;

    const response = await fetch(csvUrl);

    if (!response.ok) {

        console.error('Unable to load Holiday CSV.');

        return;

    }

    const csv = await response.text();

    parseHolidayCSV(csv);

    holidayLoaded = true;

}

function parseHolidayCSV(csv) {

    const rows = csv.trim().split(/\r?\n/);

    for (let i = 1; i < rows.length; i++) {

        const value = rows[i].trim();

        if (!value) continue;

        holidaySet.add(value);

    }

}

/* ==========================================================
   DATE ENGINE
========================================================== */
function formatHolidayKey(date) {

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;

}

function formatDeliveryDate(date) {

    return date.toLocaleDateString('en-IN', {
    weekday: 'short',
    day: 'numeric',
    month: 'short'
});

}

/* ==========================================================
   SATURDAY HELPERS
========================================================== */

function isSecondSaturday(date) {

    return (
        date.getDay() === 6 &&
        date.getDate() >= 8 &&
        date.getDate() <= 14
    );

}

function isLastSaturday(date) {

    if (date.getDay() !== 6) return false;

    const nextWeek = new Date(date);

    nextWeek.setDate(date.getDate() + 7);

    return nextWeek.getMonth() !== date.getMonth();

}

/* ==========================================================
   WORKING DAY CHECK
========================================================== */

function isWorkingDay(date) {

    const day = date.getDay();

    // Sunday
    if (day === 0) return false;

    // Second Saturday
    if (isSecondSaturday(date)) return false;

    // Last Saturday
    if (isLastSaturday(date)) return false;

    // Holiday CSV (dd-mm-yyyy)
    if (holidaySet.has(formatHolidayKey(date))) return false;

    return true;

}

/* ==========================================================
   ADD WORKING DAYS
========================================================== */

function addWorkingDays(startDate, workingDays) {

    const date = new Date(startDate);

    let remaining = workingDays;

    while (remaining > 0) {

        date.setDate(date.getDate() + 1);

        if (isWorkingDay(date)) {

            remaining--;

        }

    }

    return date;

}

/* ==========================================================
   DISPATCH DATE
========================================================== */

function getDispatchDate() {

    const now = new Date();

    const dispatch = new Date(now);

    // Dispatch cutoff = 2:00 PM
    if (now.getHours() >= 14) {

        dispatch.setDate(dispatch.getDate() + 1);

    }

    while (!isWorkingDay(dispatch)) {

        dispatch.setDate(dispatch.getDate() + 1);

    }

    return dispatch;

}

/* ==========================================================
   DELIVERY RANGE
========================================================== */

function calculateDeliveryRange(record) {

    const dispatchDate = getDispatchDate();

    const startDate = addWorkingDays(dispatchDate, record.min);

    const endDate = addWorkingDays(dispatchDate, record.max);

    return {
        start: formatDeliveryDate(startDate),
        end: formatDeliveryDate(endDate)
    };

}

/* ==========================================================
   LOOKUP
========================================================== */
function lookupPincode(pincode, root) {

    const entry = root.querySelector('[data-delivery-entry]');
    const result = root.querySelector('[data-delivery-result]');
    const error = root.querySelector('[data-delivery-error]');
    const loading = root.querySelector('[data-delivery-loading]');

    const location = root.querySelector('[data-delivery-location]');
    const status = root.querySelector('[data-delivery-status]');
    const dates = root.querySelector('[data-delivery-dates]');

    error.hidden = true;
    result.hidden = true;
    loading.hidden = false;

   if (pincode.length !== 6) {

    return;

}

    const record = deliveryLookup.get(pincode);

    setTimeout(function () {

        loading.hidden = false;

       // If pincode not found in CSV, use a default delivery estimate
let deliveryRecord = record;

if (!deliveryRecord) {

    deliveryRecord = {
        min: 5,
        max: 6,
        serviceable: true
    };

}

// If pincode is explicitly marked as non-serviceable
if (!deliveryRecord.serviceable) {

    loading.hidden = true;

    error.hidden = false;

    error.querySelector('p').textContent =
        "Sorry! We don't currently deliver to this pincode.";

    return;

}

        localStorage.setItem(STORAGE_KEY, pincode);

        const deliveryRange = calculateDeliveryRange(deliveryRecord);

        result.hidden = false;

        loading.hidden = true;

        location.hidden = true;

        status.textContent = "";

status.textContent = "";

dates.textContent =
    "Arrives between " +
    deliveryRange.start +
    " – " +
    deliveryRange.end;

    }, 250);

}
/* ==========================================================
   END
========================================================== */

})();